import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BaseAPIClass } from '@app/core/class/baseAPI.class';
import { Observable } from 'rxjs';
import { environment } from '@env/environment.prod';
import { Paginated } from '../model/paginated.model';
import { Category } from '../model/category.model';

@Injectable()
export class CategoryService extends BaseAPIClass {
  baseUrl = '';
  public isLoading = false;
  private categoriasSearchUrl = this.baseUrl + '/categorias/search?term=';

  constructor(protected httpClient: HttpClient) {
    super(httpClient);
    this.baseUrl = this.baseUrl + '/categorias';
  }

  getCategoriasHabilitdas(): Observable<Category[]> {
    return this.httpClient.get<Category[]>(this.baseUrl + '/habilitados');
  }

  getCategorias(): Promise<Paginated> {
    this.isLoading = true;
    return this.httpClient
      .get(this.baseUrl)
      .toPromise()
      .then(response => {
        this.isLoading = false;
        return response as Paginated;
      })
      .catch(this.handleError);
  }

  getProductosAtUrl(url: string): Promise<Paginated> {
    this.isLoading = true;
    return this.httpClient
      .get(url)
      .toPromise()
      .then(response => {
        this.isLoading = false;
        return response as Paginated;
      })
      .catch(this.handleError);
  }

  search(term: string): Promise<Paginated> {
    this.isLoading = true;
    return this.httpClient
      .get(`${this.categoriasSearchUrl}${term}`)
      .toPromise()
      .then(response => {
        this.isLoading = false;
        return response as Paginated;
      })
      .catch(this.handleError);
  }

  enableCategory(id: number) {
    return this.httpClient.get(this.baseUrl + '/habilitar/' + id);
  }

  private handleError(error: any): Promise<any> {
    console.error('An error occurred', error); // for demo purposes only
    // this.isLoading = false;
    return Promise.reject(error.message || error);
  }
}
